<div class="audio-text-sync-container">
  <i (click)="onPlayMessage()" class="play-button">
    @switch (iconState()) { @case ('loading') { <i class="spin-animation pi pi-spinner-dotted"></i> } @case ('playing') { <i class="pi pi-volume-up"></i> }
    @case ('paused') { <i class="pi pi-pause-circle"></i> } @case ('playable') { <dc-icon name="play"></dc-icon> } }
  </i>

  <!-- Display transcription with highlighting -->
  <p style="width: 100%" [class]="'text-content ' + classTag()">
    @for (word of wordWithMeta(); track trackByIndex($index, word)) {
    <span [class]="word.tag" [class.highlight]="word.isHighlighted" (click)="onWordClick(word)" [attr.id]="'word-' + message().messageId + '-' + word.index"
      >{{ word.word }}
    </span>
    }
  </p>
</div>
